import * as React from "react"

const ShipXLogo = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210.54 78.21" {...props}>
    <defs>
      <style>{".cls-1{fill:#b9d816}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="m174.24 40.75 16.4 16.06H177l-9-9-.08.09-35.74 30.31 30.48-35.6L210.54 0Z"
        />
        <path
          d="M73.36 24.57h8.3V57h-8.3V45.73H52.27V57H44V24.57h8.3v13.3h21.06ZM89.07 57h8.3V24.57h-8.3Zm55.34-21.6c0 7.46-5.1 10.88-13.85 10.88h-17.49V57h-8.3V24.57h25.79c8.88 0 13.85 3.29 13.85 10.83Zm-8.44 0c0-1.78-1-3-4.86-3h-18v11.09l3.87-5.07h14.17c3.85 0 4.85-1.21 4.85-3.02Zm-116.4 1.2c-8.89 0-10.71-.36-10.71-2.33 0-2.39 3.51-3.3 11-3.3a92.2 92.2 0 0 1 11.63.72l5.21-6.89A95.79 95.79 0 0 0 20 23.58C7.15 23.58.47 27.25.09 34.33c-.4 7.37 5.46 10.31 19.08 10.31 8.88 0 11.66.26 11.46 2.66s-3.8 3-11.48 3a77.11 77.11 0 0 1-14-1.16L0 55.86c6.76 1.66 15.51 1.8 19.52 1.8 14.11 0 19.89-3.57 19.89-11S33.19 36.6 19.57 36.6Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          className="cls-1"
          d="m168.71 34.8-10.75-10.63-13.49.02 16.65 16.16 7.59-5.55z"
        />
      </g>
    </g>
  </svg>
)

export default ShipXLogo
